function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Master",
  stroke: "none",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  transform: "translate(-40.000000, -556.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(40.000000, 556.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#F0F5F6",
  cx: 20,
  cy: 20,
  r: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "Credit-card",
  transform: "translate(12.000000, 13.000000)",
  fill: "#C9D6DB",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,10.8666667 C0,12.0448741 0.8954305,13 2,13 L14,13 C15.1045695,13 16,12.0448741 16,10.8666667 L16,5 L0,5 L0,10.8666667 Z M2.35714286,7.97142857 C2.35714286,7.340246 2.83683777,6.82857143 3.42857143,6.82857143 L5.14285714,6.82857143 C5.7345908,6.82857143 6.21428571,7.340246 6.21428571,7.97142857 L6.21428571,8.73333333 C6.21428571,9.3645159 5.7345908,9.87619048 5.14285714,9.87619048 L3.42857143,9.87619048 C2.83683777,9.87619048 2.35714286,9.3645159 2.35714286,8.73333333 L2.35714286,7.97142857 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14,0 L2,0 C0.8954305,0 0,0.917270269 0,2.04878049 L0,3 L16,3 L16,2.04878049 C16,0.917270269 15.1045695,0 14,0 Z",
  id: "Path"
})))));

var SvgCardRound = function SvgCardRound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCardRound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/card-round.e5307753.svg";
export { ForwardRef as ReactComponent };